import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component HistoryOfChangesIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <HistoryOfChangesIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <HistoryOfChangesIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const HistoryOfChangesIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="HistoryOfChangesIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M10.33 4.176a8 8 0 11-.113 15.623l-.446 1.95a10 10 0 10-5.196-3.05l-.008.008.242.242.05.051H3.274a1 1 0 100 2h4a1 1 0 001-1v-4a1 1 0 10-2 0v1.586l-.038-.038a8 8 0 014.095-13.372z" />
      <path d="M12 13h4v2h-6V8h2v5z" />
    </svg>
  )
);
HistoryOfChangesIcon.displayName = "HistoryOfChangesIcon";
export default HistoryOfChangesIcon;
